import { useEffect, useState } from 'react';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import Button from '@mui/joy/Button';
import {
  Link
} from "react-router-dom";
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import ModeToggle from "../other/modetoggle"
import LoginPanel from './loginpanel';
import Grid from '@mui/joy/Grid';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import {
  useAppKitAccount,
  useAppKitProvider,
  useAppKitNetworkCore,
  useAppKit,
} from "@reown/appkit/react";
import { BACKEND_API_URL, BACKEND_IP_ADDRESS } from '../data/constant';
import { useNavigate } from 'react-router-dom';
import { VerifyWeb3Login } from './loginpanel';
import {
  BrowserProvider,
  JsonRpcSigner,
  formatEther,
  parseUnits,
} from "ethers"



export default function NavBar(arr) {
  const { address, isConnected, caipAddress, status, disconnect } = useAppKitAccount()
  const [ProfileName, setProfileName] = useState(null)
  const [loggedin, setLoggedin] = useState(false)
  const [web3Loggedin, setWeb3Loggedin] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const { chainId } = useAppKitNetworkCore();

  function Logout() {
    fetch(BACKEND_API_URL + 'logout')
      .then(response => {
        console.log(response)
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Use response.url to check the final URL after redirection
        return response.json(); // Assuming the response is in JSON format
      })
      .then(data => {
        // Handle the JSON data from the final response
        // if (isConnected) {
        //   disconnect()
        // }
        Cookies.remove('tier');
        Cookies.remove('user');
        console.log(data);
        setProfileName(null)
        setLoggedin(false)
        // window.location.href = 'https://' + BACKEND_IP_ADDRESS;
      })
      .catch(error => {
        // Handle errors that occurred during the request or redirection
        console.error('Fetch error:', error);
      });
    return <div>You Have been logout</div>;
  }
  useEffect(() => {
    if (Cookies.get('user') != null && Cookies.get('user') != "") {
      setProfileName(Cookies.get('user'))
      setLoggedin(true)
    }
  }, [location]); //
  useEffect(() => {
    if (isConnected) {
      setWeb3Loggedin(true)
      if (Cookies.get('user') == null) {

        const walletProvider = window.ethereum;
        const provider = new BrowserProvider(walletProvider, chainId);
        const signer = new JsonRpcSigner(provider, address);
        VerifyWeb3Login(address, signer, navigate)
        // hasTriggered.current = true; // Mark as triggered
      }
    }
    else if (web3Loggedin) {
      setWeb3Loggedin(true)
      Logout(navigate)
    }
    // alert(loggedin)
  }, [isConnected]);
  return (
    <div style={{ display: "inline-flex", width: "100%" }}>
      <div style={{ textAlign: "left", display: "inline-flex", maxWidth: "30%", maxHeight: "10%", justifyContent: "flex-start" }}>
        <Link style={{ color: 'inherit', textDecoration: 'inherit', marginRight: "5%", marginLeft: "3%", textAlign: "center" }} to={"/"} >
          <h1 style={{ fontSize: "1vw" }}>DevOps Penguin</h1>

        </Link>
        <div style={{ width: "5vw", marginTop: "2vh" }}>
          {ModeToggle()}
        </div>
      </div>
      <div style={{ display: "inline-flex", justifyContent: "flex-end", marginLeft: "auto", width: "auto" }}>
        {arr.map((item, index) => (
          <div style={{ width: `${100 / arr.length}%` }}>
            <Link style={{ color: 'inherit', textDecoration: 'inherit', width: "inherit" }} to={"/" + item.text.replace(" ", "_").toLowerCase()} >
              <Button variant="plain" sx={{ width: "fit-content" }}>
                <div style={{ fontSize: "1vw", width: "inherit" }}>{item.text}</div>
              </Button>
            </Link>
          </div>
        ))}
        <div style={{ width: `${100 / arr.length}%` }}>
          {loggedin ?
            // <Button variant="plain" sx={{ fontSize: "100%", height: "100%", width: "100%" }}>
            <Select placeholder={ProfileName} sx={{ indicator: "none", width: "100%" }}>
              <Option>
                <Button variant="plain">
                  <Link style={{ color: 'inherit', textDecoration: 'inherit' }} to={"/profile"}>
                    Profile
                  </Link>
                </Button>
              </Option>
              <Option>
                <Button variant="plain" onClick={
                  () => {
                    Logout(navigate)
                  }}>
                  <Link style={{ color: 'inherit', textDecoration: 'inherit' }} >
                    Logout
                  </Link>
                </Button>
              </Option>
            </Select>
            : <LoginPanel setloggedin={setLoggedin} />}
        </div>
      </div>
    </div>
  );
}